import React from "react";
import useSecurityObject from "../../hooks/useSecurityObject";

type Props = {
    objectCode: string;
    children: React.ReactElement;
    disabled?: boolean;
    require?: "read" | "write";
};

export function SafetyComponent({
    objectCode,
    children,
    disabled,
    require = "read",
}: Props) {
    const { hasReadPermission, hasWritePermission } = useSecurityObject();

    const canRead = hasReadPermission(objectCode);
    if (!canRead) return null;

    // Para "read" no inyectamos props (evita problemas de tipado y de componentes custom).
    if (require === "read") {
        return children;
    }

    // require === "write"
    const canWrite = hasWritePermission(objectCode);

    
    return React.cloneElement(children as React.ReactElement<any>, {
        disabled: disabled || !canWrite,
    });
}














